
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeVariant: null
    }
  },
  computed: {
    variant() {
      return this.product.variantsCount > 0
        ? this.activeVariant || this.product.variants[0]
        : this.product.master
    },
    buttonAttrs() {
      return {
        type: 'success',
        icon: 'plus-circle',
        message: true
      }
    }
  },
  methods: {
    onSetVariant(variant) {
      this.activeVariant = variant
      this.$emit('set-variant', variant)
    }
  }
}
